




































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Mutation } from "vuex-class";

@Component
class AddressSelectAction extends Vue {
  @Mutation("wallet/mixin/ADD_ADDED_ASSET") addAddedAsset;

  @Prop() cryptoAsset;

  dialog = false;

  loading = false;

  get meta() {
    const getAssetById = this.$store.getters["wallet/mixin/getAssetById"];
    const asset = getAssetById(this.cryptoAsset?.id);

    return {
      asset,
      symbol: this.cryptoAsset?.symbol ?? ""
    };
  }

  @Watch("cryptoAsset", { immediate: true })
  handleAssetChange() {
    if (this.meta.asset) {
      this.$emit("select", this.meta.asset.destination);
    }
  }

  handleSetAddress(address: string) {
    this.$emit("select", address);
    this.dialog = false;
  }

  handleAddAsset() {
    this.requestAddAsset(this.cryptoAsset.id);
  }

  async requestAddAsset(id) {
    this.loading = true;
    try {
      const asset = await this.$api.wallet.mixin.getAsset(id);
      this.addAddedAsset(asset);
      this.handleSetAddress(asset.destination);
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
    this.loading = false;
  }
}
export default AddressSelectAction;
